/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as selectorsNsir from '../../store/nsir/reducer';
import { isUsoMutuo, isInspecaoFibraOptica } from 'utils';
import UsoMutuoModal from './nsmp-view/UsoMutuoModal';
import DefaultModal from './nsmp-view/DefaultModal';
import UsoMutuoNewModal from './nsmp-view/UsoMutuoNewModal';
import FibraOpticaModal from './nsmp-view/FibraOpticaModal';

const NsmpModal = ({ open, onCancel, onConfirm, onConfirmAndNext, selectedId, readOnly, nsirData, nsirTitle,
  onNext, onPrevious, hasNext, hasPrevious, carouselPosition }) => {
  if (isUsoMutuo(nsirData.tipoServicoId) && !!nsirData.newFlow) {
    return <UsoMutuoNewModal
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      selectedId={selectedId}
      readOnly={readOnly}
      nsirTitle={nsirTitle}
      digitadorId={nsirData.digitadorId}
      inspetorId={nsirData.inspetorId}
      onNext={onNext}
      onPrevious={onPrevious}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      carouselPosition={carouselPosition}
    />
  } else if (isUsoMutuo(nsirData.tipoServicoId)) {
    return <UsoMutuoModal
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      onConfirmAndNext={onConfirmAndNext}
      selectedId={selectedId}
      readOnly={readOnly}
      nsirTitle={nsirTitle}
      digitadorId={nsirData.digitadorId}
      onNext={onNext}
      onPrevious={onPrevious}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      carouselPosition={carouselPosition}
    />
  } else if (isInspecaoFibraOptica(nsirData.tipoServicoId) && !!nsirData.newFlow) {
    return <FibraOpticaModal
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      onConfirmAndNext={onConfirmAndNext}
      selectedId={selectedId}
      readOnly={readOnly}
      nsirTitle={nsirTitle}
      digitadorId={nsirData.digitadorId}
      onNext={onNext}
      onPrevious={onPrevious}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      carouselPosition={carouselPosition}
    />
  }

  return <DefaultModal
    open={open}
    onCancel={onCancel}
    onConfirm={onConfirm}
    onConfirmAndNext={onConfirmAndNext}
    selectedId={selectedId}
    readOnly={readOnly}
    nsirTitle={nsirTitle}
    onNext={onNext}
    onPrevious={onPrevious}
    hasNext={hasNext}
    hasPrevious={hasPrevious}
    carouselPosition={carouselPosition}
  />
};

NsmpModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onConfirmAndNext: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selectedId: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  nsirData: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  hasNext: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  carouselPosition: PropTypes.object,
};

NsmpModal.defaultProps = {
  selectedId: undefined,
};

const mapStateToProps = state => ({
  nsirData: selectorsNsir.getNsirSelected(state),
});

export default connect(mapStateToProps, null)(NsmpModal);
